var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-info-new"},[_c('div',{staticClass:"welcome-tip"},[_c('span',{staticClass:"desc"},[_vm._v("欢迎访问武汉市前期物业管理电子招投标系统~")]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.currentTime))])])])}
var staticRenderFns = []

export { render, staticRenderFns }